import theme from '../../../lib/theme';
import { ImageProps } from './Image';

const { colors } = theme;

export default ({ 
  brand = 'sas', 
  color, 
  border, 
}: ImageProps) => ({
  image: {
    display: 'inherit',
    ...(color && { backgroundColor: colors[brand][color] || colors[color] }),
    ...(border && {
      borderStyle: 'solid',
      borderWidth: border ? 2 : 0,
      borderColor: border
        ? colors[brand][border] || colors[border]
        : 'transparent',
    }),
  },
});
